'use client';

import { useSyncExternalStore } from 'react';
import { useIsMobileOverride } from '@jlg-website/editor/is-mobile';

const LG_BREAKPOINT_PX = 1024;

function subscribe(callback: () => void): () => void {
  window.addEventListener('resize', callback);
  window.visualViewport?.addEventListener('resize', callback);
  return () => {
    window.removeEventListener('resize', callback);
    window.visualViewport?.removeEventListener('resize', callback);
  };
}

function getSnapshot(): boolean {
  return window.innerWidth < LG_BREAKPOINT_PX;
}

export function useIsMobile(initialValue: boolean = false): boolean {
  const override = useIsMobileOverride();
  const storeValue = useSyncExternalStore(subscribe, getSnapshot, () => initialValue);
  return override ?? storeValue;
}
